export const BUY = 'buy'
export const RECOURSE = 'recourse'
export const SERVICE = 'service'
export const DENIED = 'denied'
